/*
 * IllustrationPage Messages
 *
 * This contains all the text for the IllustrationPage container.
 */
import { defineMessages } from 'react-intl';
export const scope = 'app.containers.IllustrationPage';
export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Illustrations',
  },
  newIllustratoin: {
    id: `${scope}.newIllustratoin`,
    defaultMessage: 'New Illustration',
  },
  newCustomer: {
    id: `${scope}.newCustomer`,
    defaultMessage: 'New Customer',
  },
  existingCustomer: {
    id: `${scope}.existingCustomer`,
    defaultMessage: 'Existing Customer',
  },
  chooseProduct: {
    id: `${scope}.chooseProduct`,
    defaultMessage: 'Choose your product',
  },
  selectAProduct: {
    id: `${scope}.selectAProduct`,
    defaultMessage: 'Select a product',
  },
  ita: {
    id: `${scope}.ita`,
    defaultMessage: '1. ITA-International Term Assurance',
  },
  futura: {
    id: `${scope}.futura`,
    defaultMessage: '2. FUT-Futura',
  },
  processThisOne: {
    id: `${scope}.processThisOne`,
    defaultMessage: 'Process this one',
  },
  makeAnother: {
    id: `${scope}.makeAnother`,
    defaultMessage: 'Make another',
  },
  clientListIllustratoin: {
    id: `${scope}.clientListIllustratoin`,
    defaultMessage: 'Client list: Frank Skinner',
  },
  productITA: {
    id: `${scope}.productITA`,
    defaultMessage: 'International Term Assurance',
  },
  productFUTU: {
    id: `${scope}.productFUTU`,
    defaultMessage: 'Futura',
  },
  productMFS01: {
    id: `${scope}.productMFS01`,
    defaultMessage: 'Global Choice',
  },
  productDTME2: {
    id: `${scope}.productDTME2`,
    defaultMessage: 'International Decreasing Term Assurance',
  },
  productSW: {
    id: `${scope}.productSW`,
    defaultMessage: 'Simple Wealth Plan',
  },
  productRSP: {
    id: `${scope}.productRSP`,
    defaultMessage: 'Legacy',
  },
  productWAP: {
    id: `${scope}.productWAP`,
    defaultMessage: 'Wealth Accumulation Plan',
  },
  emailPDF: {
    id: `${scope}.emailPDF`,
    defaultMessage: 'Email PDF',
  },
  clear: {
    id: `${scope}.clear`,
    defaultMessage: 'Clear',
  },
  choose: {
    id: `${scope}.choose`,
    defaultMessage: 'Choose',
  },
  customers: {
    id: `${scope}.customers`,
    defaultMessage: 'Customers',
  },
  ci: {
    id: `${scope}.ci`,
    defaultMessage: 'Critical illness',
  },
  protectionBenefit: {
    id: `${scope}.protectionBenefit`,
    defaultMessage: 'Protection benefit',
  },
  lifeCover: {
    id: `${scope}.lifeCover`,
    defaultMessage: 'Life cover',
  },
  waiver: {
    id: `${scope}.waiver`,
    defaultMessage: 'Waiver',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  view: {
    id: `${scope}.view`,
    defaultMessage: 'View',
  },
});
